import React from 'react';
import { Route, Routes } from 'react-router-dom';
import {
  AsyncOrderMainComponent,
  AsyncOrderMainDetailComponent,
  AsyncOrderShoppingCartComponent,
  AsyncOrderConfirmComponent,
  AsyncOrderCompleteComponent,
} from 'Components/AsyncComponent/AsyncComponent';
import useTab from './hooks/useTab';
import { TabProvider } from './context/TabContext.jsx';
import useShoppingCart from './hooks/useShoppingCart';
import { ShoppingCartProvider } from './context/ShoppingCartContext.jsx';

const Order = () => {
  const { tab, setTab } = useTab();
  const shoppingCartData = useShoppingCart();

  return (
    <>
      <TabProvider value={{ tab, setTab }}>
        <ShoppingCartProvider value={shoppingCartData}>
          <div className='content-wrapper'>
            <Routes>
              <Route path='' element={<AsyncOrderMainComponent />} />
              <Route path=':id/:optionId' element={<AsyncOrderMainDetailComponent />} />
              <Route path='shopping-cart' element={<AsyncOrderShoppingCartComponent />} />
              <Route path='confirm' element={<AsyncOrderConfirmComponent />} />
              <Route path='complete' element={<AsyncOrderCompleteComponent />} />
            </Routes>
          </div>
        </ShoppingCartProvider>
      </TabProvider>
    </>
  );
};

export default Order;
